// eslint-disable-next-line import/no-extraneous-dependencies
import { disconnect } from '@wagmi/core';
import axios from 'axios';
import { API_BASE_URL, logger, removeStoredAuthTokens, retrieveStoredAuthTokens, storeAuthTokens } from 'shared';
import { wagmiConfig } from 'shared/config/wagmi';

import { resetAuthState } from '../store/utils/persist-auth-state';
import { AuthTokens } from '../types';

export const refreshAuthToken = async () => {
  const storedTokensPair = retrieveStoredAuthTokens();
  if (!storedTokensPair?.refresh) {
    throw new Error('No refresh token available');
  }

  try {
    const refreshClient = axios.create({
      baseURL: API_BASE_URL,
      headers: { 'Content-Type': 'application/json' },
      timeout: 10000,
    });

    const { data } = await refreshClient.post<Pick<AuthTokens, 'access'>>('/accounts/token/refresh/', {
      refresh: storedTokensPair.refresh,
    });

    storeAuthTokens({
      access: data.access,
      refresh: storedTokensPair.refresh,
    });

    return data;
  } catch (error: unknown) {
    await disconnect(wagmiConfig);
    removeStoredAuthTokens();
    resetAuthState();
    if (axios.isAxiosError(error)) {
      logger('Refresh expired:', error.response?.data, 'error');
    }

    throw error;
  }
};
